import { snakeCase } from 'snake-case';

import { DELIVERY_TYPES } from '~constants/delivery';
import {
  ORDER_STATUS,
  PAYMENT_METHODS,
  DISPATCH_METHODS,
  SORT_BY_STATUS_FIELD,
  ORDER_TYPE
} from '~constants/orders';

export const isPeya = (order) => order?.deliveries?.[0]?.type === DELIVERY_TYPES.PEYA;

export const isOnline = (paymentMethod) => paymentMethod === PAYMENT_METHODS.ONLINE;

export const getCompletedPayment = (order) =>
  order?.payments?.find(({ status }) => status === ORDER_STATUS.COMPLETED);

export const formatPaymentType = (type = '') => snakeCase(type.replace(/Payment/, ''));

export const getActualDate = ({ paymentMethod, paymentDatetime, createdAt }) =>
  paymentMethod === PAYMENT_METHODS.ONLINE ? paymentDatetime : createdAt;

export const isDelivery = ({ dispatchMethod }) =>
  dispatchMethod === DISPATCH_METHODS.delivery || dispatchMethod === DISPATCH_METHODS.store_delivery;

const sortConfig = {
  [ORDER_STATUS.SCHEDULED]: (orderA, orderB) => {
    const fieldName = SORT_BY_STATUS_FIELD[ORDER_STATUS.SCHEDULED];
    return new Date(orderA[fieldName]).getTime() - new Date(orderB[fieldName]).getTime();
  },
  default: () => true
};

export const sortByStatus = ([status]) => sortConfig[status] || sortConfig.default;

export const getOrderType = ({ deferred, forLater }) =>
  forLater ? ORDER_TYPE.SCHEDULED : deferred ? ORDER_TYPE.DEFERRED : ORDER_TYPE.DEFAULT;
